module.exports = __webpack_public_path__ + "static/assets/e115c935d344a357cee1b0ba440638b0.png";